import React from 'react'
import { IscFundersDashboard } from './components/IscFundersDashboard'

const IscFundersApp: React.FC = () => {
  return <IscFundersDashboard />
}

export default IscFundersApp
